import { render, staticRenderFns } from "./ModalConfiguracao.vue?vue&type=template&id=70e0c8fe&"
import script from "./ModalConfiguracao.vue?vue&type=script&lang=js&"
export * from "./ModalConfiguracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports